/**
 * Map PassportRequestTypeEnum values from BE to display strings.
 */
export const PASSPORT_REQUEST_TYPE_LABELS = {
    INITIAL:   'Neuantrag (Initial request)',
    TRANSFER:  'Clubwechsel (Transfer request)',
    TEMPORARY: 'Temporär (Temporary)',
    CHANGE:    'Passänderung (Change)',
};

/**
 * @param {string|null|undefined} typeValue
 * @returns {string}
 */
export function getPassportRequestTypeLabelFromEnumKey(typeValue) {
    if (!typeValue) return '';
    return PASSPORT_REQUEST_TYPE_LABELS[typeValue] ?? typeValue;
}
